import {
  Checkbox,
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { memo, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { getData, storeData, callChoice } from "../../utils/GlobalHelper";
import HeaderPage from "../../components/HeaderPage/Index";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";
import clsx from "clsx";
import GlobalApi from "../../utils/GlobalApi";
import Loading from "../../components/loading/loading";
import ButtonConcent from "../../components/BoxRightContent/ButtonConcent";
import { isEmpty } from "lodash";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
import Configs from "../../constants/Configs";

const useStyle = makeStyles({
  font: {
    fontFamily: "DB Heavent",
  },
  content: {
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "var(----text-black)",
  },
});

const ThaiDCondition = (props) => {
  const classes = useStyle();
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isRead, setIsRead] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [consent, setConsent] = useState({
    checkboxText: "",
    termConText: "",
    titleText: "",
    btnOk: "",
    btnCancel: "",
  });
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  const ats = getData("f7_ats");
  const bank_ats = getData("f7_bank_ats");
  const summary = getData("passedSummary");
  let snapIdCard = getData("uploadImage");
  let uploadImgSign = getData("uploadImageSign");
  let uploadImageBookBank = getData("uploadImageBookBank");

  const checkJumpPage = async () => {
    var stamp_page = getData("stamp_page");
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });
    console.log(stamp_page);

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(uploadImgSign) ||
      isEmpty(ats) ||
      isEmpty(bank_ats) ||
      (isEmpty(uploadImageBookBank) && ats.f7_isother === "1") ||
      (stamp_page !== "EKYC" &&
        stamp_page !== "CONFIRM" &&
        stamp_page !== "ThaID")
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "uploadImageBookBank") {
                  uploadImageBookBank =
                    element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const oninitData = () => {
    const oldCheck = getData("page_agree");
    if (oldCheck.ThaID === 1) {
      setChecked(true);
      setIsRead(true);
    }
  };
  const callGetConsent = async () => {
    setIsLoading(true);
    try {
      const header = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      await GlobalApi.get(
        Configs.baseURL + "/api/consent?id=daol_tc_thaid",
        header,
      )
        .then((res) => {
          setIsLoading(false);
          res?.data?.data.forEach((row) => {
            setConsent({
              checkboxText: row?.checkBox,
              termConText: row?.detail,
              titleText: row?.title,
              btnOk: row?.okBtn,
              btnCancel: row?.cancelBtn ? row?.cancelBtn : "",
            });
          });
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };
  const handleNext = (e) => {
    e.preventDefault();
    const page_agree_old = getData("page_agree");
    let page_agree = { ...page_agree_old, ThaID: 1 };
    storeData("page_agree", page_agree);
    props.history.push("/thaid_waiting");
  };
  const onConfirm = (read) => {
    setIsRead(read);
  };
  // const saveComeback = async (type) => {
  //   storeData("stamp_page", type);
  //   var last_stamp = JSON.stringify(await getAllStorage(type));
  //   const saveData = [
  //     {
  //       name: "comeback",
  //       url: `${Configs.baseAPIURL03}/form/comeback/manp`,
  //       postData: {
  //         head_token: head_token,
  //         last_stamp: last_stamp,
  //         stamp_page: type,
  //       },
  //     },
  //   ];
  //   setIsLoading(true);
  //   try {
  //     await GlobalApi.post(
  //       saveData[0].url,
  //       qs.stringify(saveData[0].postData),
  //       {
  //         headers: {
  //           "Content-Type": "application/x-www-form-urlencoded",
  //           Accept: "application/json",
  //         },
  //       }
  //     )
  //       .then((res) => {
  //         setIsLoading(false);
  //         if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
  //           let mss =
  //             res.data.Data[0].MsgDesc !== ""
  //               ? res.data.Data[0].MsgDesc
  //               : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
  //           let title = "เกิดข้อผิดพลาด";
  //           setIsLoading(false);
  //           setIsModalError(true);
  //           setModalErrorTitle(title);
  //           setModalErrorDes(mss);
  //         } else {
  //           switch (type) {
  //             case "NDID":
  //               props.history.push("/ndid_information");
  //               break;
  //             case "EKYC":
  //               props.history.push("/ekyc");
  //               break;
  //             case "DIPCHIP":
  //               props.history.push("/dipchip_waiting");
  //               break;
  //             case "ThaID":
  //               props.history.push("/thaid_condition");
  //               break;
  //             default:
  //               props.history.push("/products_consent");
  //           }
  //           // type === "EKYC" ? props.history.push("/ekyc") : type === "CONFIRM" ? props.history.push("/products_consent") : "";
  //         }
  //       })
  //       .catch((er) => {
  //         setIsLoading(false);
  //         let title = "เกิดข้อผิดพลาด";
  //         let mss =
  //           "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
  //           getData("api_error")?.message +
  //           ")";
  //         setIsModalError(true);
  //         setModalErrorTitle(title);
  //         setModalErrorDes(mss);
  //       });
  //   } catch (error) {
  //     setIsLoading(false);
  //     setIsModalError(true);
  //   }
  // };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        callGetConsent();
        oninitData();
      }
    });
  }, []);

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.ndid_condition?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => {
              storeData("stamp_page", "EKYC");
              e ? props.history.push("/ekyc") : "";
            }}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.ndid_condition}
                        clickBack={(e) => {
                          storeData("stamp_page", "EKYC");
                          props.history.push("/ekyc");
                        }}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          {!isMobile && (
                            <HeaderRight
                              title={
                                translations?.[lang]?.ndid_condition?.title
                              }
                            />
                          )}
                          <PanelScrollBar
                            content={
                              <Grid container>
                                <Grid className="sub-title">
                                  <Typography
                                    className={clsx(
                                      "box-title text-left font-20",
                                    )}
                                    dangerouslySetInnerHTML={{
                                      __html: consent.titleText,
                                    }}
                                  />
                                </Grid>
                                <Grid className={classes.content}>
                                  <Grid
                                    className={clsx(classes.font, "font-20")}
                                    dangerouslySetInnerHTML={{
                                      __html: consent.termConText,
                                    }}
                                  ></Grid>
                                </Grid>
                              </Grid>
                            }
                            confirmRead={onConfirm}
                          />
                          {/* check box content */}
                          <Grid>
                            <Grid className="checkbox-consent">
                              <Checkbox
                                className="check-box-deco"
                                sx={{
                                  color: "#023b66",
                                  opacity: "0.8",
                                  "&.Mui-checked": {
                                    color: "#023b66",
                                    opacity: "0.8",
                                  },
                                }}
                                disabled={!isRead}
                                checked={checked}
                                onChange={handleCheck}
                              />
                              <Grid
                                onClick={(e) => {
                                  if (isRead) {
                                    setChecked(!checked);
                                  } else {
                                    setChecked(false);
                                  }
                                }}
                                className={clsx(
                                  classes.content,
                                  isMobile
                                    ? "content-check-box-mb"
                                    : "content-check-box",
                                  "text-left font-18 product-choice-p",
                                  !isRead ? "checkbox-unread" : "checkbox-read",
                                )}
                                dangerouslySetInnerHTML={{
                                  __html: consent.checkboxText,
                                }}
                              ></Grid>
                            </Grid>
                          </Grid>{" "}
                          {/* button */}
                          <ButtonConcent
                            ndid
                            textOk={consent?.btnOk}
                            textCancel={consent?.btnCancel}
                            isDisbled={!checked}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(ThaiDCondition);
